/* eslint-disable import/no-anonymous-default-export */

class FlutterCommunication {
  callPhoneFromWebViewMethod(phoneNumber: any) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("Call", phoneNumber)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //---------------call flutter for get currentlocatin From  flutter--------------
  async callcurrenLocationFromWebViewMethod(callBack: any) {
    if ((window as any).flutter_inappwebview === undefined) {
      callBack && callBack(null);
    } else {
      (window as any).flutter_inappwebview
        .callHandler("CurrentLocationPassenger", "")
        .then(function (result: String) {
          (window as any).CurrentLocationPassengerFunc =
            function CurrentLocationPassengerFunc(
              lat: any,
              lng: any,
              heading: number
            ) {
              callBack && callBack({ lat, lng, heading });
            };
        });
    }
  }
  async getcurrentLocationFromWebViewMethod(getPermision?: boolean) {
    // if (!this.isFlutter()) {
    //   return null;
    // } else {
    var locationStr = await (window as any).flutter_inappwebview.callHandler(
      "GetCurrentLocation",
      getPermision
    );

    return locationStr;
    // }
  }

  //---------------call flutter for payment--------------
  paymentFromWebView(orderId: string) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("Payment", orderId)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //---------------call flutter for savePdf in mobile--------------
  savePdfFromWebView(base64File: string) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("SaveDownloadFile", base64File)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //---------------sendAccessTokenToflutter--------------
  loginFromWebView(loginModel: string) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("login", loginModel)
        .then(function (result: any) {});
    }
    return callFlutter;
  }
  //--------singoutFromWebview---------------------
  signOutWebView() {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("SignOut", "")
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //-------signalRFromWebview---------------------
  async callConnectSignalR(callBack: any) {
    if ((window as any).flutter_inappwebview === undefined) {
      callBack && callBack(null);
    } else {
      (window as any).flutter_inappwebview
        .callHandler("ConnectSignalR", "")
        .then(function (result: String) {
          (window as any).ConnectSignalRFunc = function ConnectSignalRFunc(
            connectes: any
          ) {
            callBack && callBack(connectes);
          };
        });
    }
  }
  isFlutter() {
    return (window as any).flutter_inappwebview !== undefined;
  }
  //-------exitAppFromWebview---------------------
  exitAppFromWebview() {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("ExitApp", "")
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }

  forceStopApp() {
    (window as any).flutter_inappwebview.callHandler("ForceStopApp", "");
  }
  //---------------openNewTab--------------
  openNewTabFromWebView(url: string) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("OpenNewTab", url)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //---------------openNewTab--------------
  changeUrlFromWebView(url: string) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("OpenNewTab", url)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  exitAppWithBtnFromWebView() {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;

      (window as any).flutter_inappwebview
        .callHandler("ExitAppWithBtn", "")
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
  //----------------------------------------
  shareLinkToAnotherAppFromWebView(url: any) {
    var callFlutter = false;
    if ((window as any).flutter_inappwebview !== undefined) {
      callFlutter = true;
      (window as any).flutter_inappwebview
        .callHandler("ShareLinkToAnotherApp", url)
        .then(function (result: any) {});
    } else {
      callFlutter = false;
    }
    return callFlutter;
  }
}

export default new FlutterCommunication();
